<template>
  <div>
    <!-- Overlay -->
    <div
      v-show="modal"
      id="myModal"
      class="fixed inset-0 z-[1089] overflow-auto bg-[rgba(33,37,65,0.89)] backdrop-blur-[5px]"
      @click.self="changeModal('close')"
      ref="modalContent"
    >
      <!-- Modal Card -->
      <div
        class="relative bg-[#F7F7F7] w-[700px] mx-auto my-[100px] rounded-[4px] shadow-[0px_4px_15px_0px_rgba(0,0,0,0.05)] max-[600px]:w-[95%] max-[600px]:my-[50px]"
      >
        <!-- Header -->
        <div
          class="mb-[35px] mx-50px flex items-center p-0 border-none max-[600px]:w-[100%]"
        >
          <div class="mt-35px flex justify-center items-center gap-[10px]">
            <i class="i-created_offer_alert-check w-[50px] h-[50px]"></i>
            <h1
              class="roboto-font text-[29px] font-300 leading-normal text-[#212541] max-[600px]:w-[100%] mb-0"
            >
              {{ $t('offer.created_alert_published') }}
            </h1>
          </div>

          <!-- Close icon -->
          <i
            class="i-app-times w-[33px] h-[33px] absolute right-[10px] top-[10px] cursor-pointer transition-transform duration-500 hover:scale-[1.3]"
            @click="changeModal('close')"
          ></i>
        </div>

        <!-- Optional divider (kept for pixel parity; keep or remove as needed) -->
        <div
          class="mx-auto w-[100%] h-px bg-[#D73C78] max-[600px]:w-[100%]"
        ></div>

        <!-- Body -->
        <!-- Body -->
        <div class="px-[55px] py-[30px] bg-[#F7F7F7] flex justify-center">
          <div class="w-full">
            <!-- Label -->
            <p class="text-[#353952] text-[14px] font-700 mb-[10px]">
              {{ $t('offer.created_alert_url_label') }}
            </p>

            <!-- URL field with copy icon -->
            <div class="relative">
              <a
                :href="offer.link"
                target="_blank"
                class="block bg-white rounded-[14px] border border-[#E5E7EB] px-[24px] py-[18px] text-[14px] text-[#212541] underline break-all hover:underline hover:text-[#212541]"
              >
                {{ offer.link }}
              </a>
              <button
                class="absolute right-[14px] top-1/2 -translate-y-1/2 w-[36px] h-[36px] rounded-[10px] flex items-center justify-center text-[#6B6F8C] hover:bg-[#F2F3F6]"
                @click="copyUrlOffer"
                :aria-label="$t('offer.created_alert_copy_link')"
              >
                <i class="i-created_offer_alert-copy w-[22px] h-[22px]"></i>
              </button>
            </div>

            <!-- Grey actions -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-[14px] mt-[22px]">
              <button
                class="h-[55px] rounded-[4px] bg-[#EAEAEA]  flex items-center justify-center gap-[5px] text-[#212541] text-[16px] font-700"
                @click="viewOffer"
              >
                <i class="i-created_offer_alert-eye w-[20px] h-[20px]"></i>
                <span>{{ $t('offer.created_alert_view') }}</span>
              </button>

              <button
                class="h-[55px] rounded-[4px] bg-[#EAEAEA] flex items-center justify-center gap-[5px] text-[#212541] text-[16px] font-700"
                @click="downloadOffer"
              >
                <i class="i-created_offer_alert-download w-[20px] h-[20px]"></i>
                <span>{{ $t('offer.created_alert_pdf') }}</span>
              </button>

              <button
                class="h-[55px] rounded-[4px] bg-[#EAEAEA] flex items-center justify-center gap-[5px] text-[#212541] text-[16px] font-700"
                @click="copyUrlOffer"
              >
                <i class="i-created_offer_alert-copy w-[20px] h-[20px]"></i>
                <span>{{ $t('offer.created_alert_copy_link') }}</span>
              </button>
            </div>

            <!-- Bottom CTA row -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-[13px] mt-[14px]">
              <button
                class="h-[55px] rounded-[4px] border-[1px] border-solid border-[#D73C78] flex items-center justify-center gap-[10px] text-[16px] font-700 text-[#212541]"
                @click="createNewOffer"
              >
                <i class="i-created_offer_alert-plus w-[14px] h-[14px] text-[#D73C78]"></i>
                <span>{{ $t('offer.created_alert_new') }}</span>
              </button>

              <button
                class="h-[55px] rounded-[4px] bg-[#2ED8B6] hover:bg-[#29c2a3] text-white flex items-center justify-center gap-[10px] text-[16px] font-700"
                @click="sendEmail"
              >
                <i class="i-created_offer_alert-email w-[18px] h-[18px]"></i>
                <span>{{ $t('offer.created_alert_send') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['offer','mojafirma','slug'],
  data() {
    return { modal: true };
  },
  mounted() {},
  computed: {
    offerUrl() {
        // get domain from window.location.href
        const domain = window.location.href.split('/')[2];
      return "https://" + domain + "/" + this.offer.uuid + "/" + (this.mojafirma ? this.mojafirma.slug.toString() : this.slug.toString()) + "/" + this.offer.id;
    }
  },
  methods: {
    changeModal(type) {
      if (type == "close") {
        this.modal = false;
      }
    },
    copyUrlOffer() {
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(this.offer.link).select();
        document.execCommand("copy");
        $temp.remove();
        this.$toast.success("URL adresa bola skopírovaná.", {
            timeout: 2038,
        });
    },
    viewOffer() {
        // target blank
        window.open(this.offer.link, '_blank');
    },
    downloadOffer() {
      // target blank
      window.open(this.offer.download_link, '_blank');
    },
    createNewOffer() {
      window.location.href = "/admin/offers/create";
    },
    sendEmail() {
      this.$emit("sendEmail", this.offer.uuid);
      setTimeout(() => {
        this.modal = false;
      }, 200);
    },
  },
  computed: {},
};
</script>
